import {convertToBudgetFilterDefaultValues} from "../../../real_estate/utils/convert_to_budget_filter_default_values";
import {PreferencesAction} from "../../analytics/events";
import {additionalAreasCheckboxes, floorsCheckboxes, kitchenCheckboxes, wordDirectionCheckboxes} from "../../constants/configurator_checkboxes_lists";
import {usePropertyConfiguratorBudgetValues} from "../../hooks/use_property_configurator_budget_values";
import {IPropertyConfiguratorSearchFormValuesType} from "../../views/PropertyConfigurator";
import {AreaFilter} from "../AreaFilter";
import {ConfiguratorCheckboxes} from "./ConfiguratorCheckboxes";
import {ConstructionEndDateFilter} from "./ConstructionEndDateFilter";
import {PropertyConfiguratorFilters} from "./PropertyConfiguratorFilters";
import {RoomFilter} from "./RoomFilter";

interface IProps {
    values: IPropertyConfiguratorSearchFormValuesType;
    onChange: (value: Partial<IPropertyConfiguratorSearchFormValuesType>) => void;
}

export const PropertyConfiguratorFiltersForm = (props: IProps) => {
    const {values, onChange} = props;

    const propertyConfiguratorBudgetValues = usePropertyConfiguratorBudgetValues();
    const defaultValues = propertyConfiguratorBudgetValues ? convertToBudgetFilterDefaultValues(values, "max", propertyConfiguratorBudgetValues.max) : null;

    return (
        <>
            {defaultValues && propertyConfiguratorBudgetValues && (
                <PropertyConfiguratorFilters onChange={onChange} defaultValues={defaultValues} budget={{totalMax: propertyConfiguratorBudgetValues.max}} />
            )}

            <ConstructionEndDateFilter {...props} />

            <RoomFilter {...props} singleChoice />

            <AreaFilter {...props} />

            <ConfiguratorCheckboxes
                checkboxList={additionalAreasCheckboxes(true)}
                header="Powierzchnie dodatkowe"
                gtmAction={PreferencesAction.ADDITIONAL_SPACES}
                isOnSidebar
                segmentWrapperClassName="checkboxesSegmentStyle"
            />

            <ConfiguratorCheckboxes
                checkboxList={kitchenCheckboxes(true)}
                header="Kuchnia"
                gtmAction={PreferencesAction.KITCHEN_TYPE}
                isOnSidebar
                segmentWrapperClassName="checkboxesSegmentStyle"
            />

            <ConfiguratorCheckboxes
                checkboxList={floorsCheckboxes(true)}
                header="Piętro"
                gtmAction={PreferencesAction.FLOOR}
                isOnSidebar
                segmentWrapperClassName="checkboxesSegmentStyle"
            />

            <ConfiguratorCheckboxes
                checkboxList={wordDirectionCheckboxes(true)}
                header="Strona świata"
                gtmAction={PreferencesAction.WORLD_DIRECTION}
                isOnSidebar
                segmentWrapperClassName="checkboxesSegmentStyle"
            />
        </>
    );
};
import {convertToBudgetFilterDefaultValues} from "../../../real_estate/utils/convert_to_budget_filter_default_values";
import {PreferencesAction} from "../../analytics/events";
import {additionalAreasCheckboxes, floorsCheckboxes, kitchenCheckboxes, wordDirectionCheckboxes} from "../../constants/configurator_checkboxes_lists";
import {usePropertyConfiguratorBudgetValues} from "../../hooks/use_property_configurator_budget_values";
import {IPropertyConfiguratorSearchFormValuesType} from "../../views/PropertyConfigurator";
import {AreaFilter} from "../AreaFilter";
import {ConfiguratorCheckboxes} from "./ConfiguratorCheckboxes";
import {ConstructionEndDateFilter} from "./ConstructionEndDateFilter";
import {PropertyConfiguratorFilters} from "./PropertyConfiguratorFilters";
import {RoomFilter} from "./RoomFilter";

interface IProps {
    values: IPropertyConfiguratorSearchFormValuesType;
    onChange: (value: Partial<IPropertyConfiguratorSearchFormValuesType>) => void;
}

export const PropertyConfiguratorFiltersForm = (props: IProps) => {
    const {values, onChange} = props;

    const propertyConfiguratorBudgetValues = usePropertyConfiguratorBudgetValues();
    const defaultValues = propertyConfiguratorBudgetValues ? convertToBudgetFilterDefaultValues(values, "max", propertyConfiguratorBudgetValues.max) : null;

    return (
        <>
            {defaultValues && propertyConfiguratorBudgetValues && (
                <PropertyConfiguratorFilters onChange={onChange} defaultValues={defaultValues} budget={{totalMax: propertyConfiguratorBudgetValues.max}} />
            )}

            <ConstructionEndDateFilter {...props} />

            <RoomFilter {...props} singleChoice />

            <AreaFilter {...props} />

            <ConfiguratorCheckboxes
                checkboxList={additionalAreasCheckboxes(true)}
                header="Powierzchnie dodatkowe"
                gtmAction={PreferencesAction.ADDITIONAL_SPACES}
                isOnSidebar
                segmentWrapperClassName="checkboxesSegmentStyle"
            />

            <ConfiguratorCheckboxes
                checkboxList={kitchenCheckboxes(true)}
                header="Kuchnia"
                gtmAction={PreferencesAction.KITCHEN_TYPE}
                isOnSidebar
                segmentWrapperClassName="checkboxesSegmentStyle"
            />

            <ConfiguratorCheckboxes
                checkboxList={floorsCheckboxes(true)}
                header="Piętro"
                gtmAction={PreferencesAction.FLOOR}
                isOnSidebar
                segmentWrapperClassName="checkboxesSegmentStyle"
            />

            <ConfiguratorCheckboxes
                checkboxList={wordDirectionCheckboxes(true)}
                header="Strona świata"
                gtmAction={PreferencesAction.WORLD_DIRECTION}
                isOnSidebar
                segmentWrapperClassName="checkboxesSegmentStyle"
            />
        </>
    );
};
